window.smoothscroll = {
  init: function () {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        const targetId = this.getAttribute("href");

        // Ignore links that are only "#", "#0" or similar.
        if (targetId.length > 1) {
          e.preventDefault();

          const targetEl = document.querySelector(targetId);
          if (targetEl) {
            targetEl.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }
      });
    });
  },
};

window.addEventListener("load", function () {
  window.smoothscroll.init();
});
